export const SUSTAINABILITY_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": [
    "Organization",
    "Corporation"
   ],
   "@id": "https://everest.ind.br/pt#organization",
   "name": "Everest Refrigeração Indústria e Comércio",
   "alternateName": "Everest",
   "url": "https://everest.ind.br/pt",
   "logo": "https://everest.ind.br/logo.png",
   "image": "https://everest.ind.br/logo.png",
   "foundingDate": "1972",
   "description": "Há mais de 50 anos uma das pioneiras e mais tradicionais indústrias fabricantes de máquinas de gelo e purificadores de água do Brasil.",
   "address": {
    "@type": "PostalAddress",
    "streetAddress": "Rua Cardoso Quintão, 914",
    "addressLocality": "Rio de Janeiro",
    "addressRegion": "RJ",
    "postalCode": "21381-460",
    "addressCountry": "BR"
   },
   "telephone": "+552136267500",
   "email": "fiscal@everest.ind.br",
   "vatID": "33.079.641/0001-32",
   "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+55 21 3626-7500",
    "contactType": "customer service",
    "areaServed": "BR",
    "availableLanguage": "Portuguese"
   },
   "sameAs": [
    "https://pt.wikipedia.org/wiki/Everest_(empresa)",
    "https://www.linkedin.com/company/everestoficial/",
    "https://www.instagram.com/everestoficial_"
   ]
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/pt#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "inLanguage": "pt-BR",
   "potentialAction": {
    "@type": "SearchAction",
    "target": "https://everest.ind.br/pt/?s={search_term_string}",
    "query-input": "required name=search_term_string"
   }
  },
  {
   "@type": "WebPage",
   "@id": "https://everest.ind.br/pt/sustentabilidade#webpage",
   "url": "https://everest.ind.br/pt/sustentabilidade",
   "name": "Sustentabilidade | Everest",
   "description": "Conheça as iniciativas de sustentabilidade da Everest: gases refrigerantes ecológicos, eficiência energética e logística reversa.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "primaryImageOfPage": "https://everest.ind.br/assets/images/logo-slogan.png",
   "dateModified": "2026-04-15",
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/sustentabilidade#breadcrumb"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/sustentabilidade#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Sustentabilidade",
     "item": "https://everest.ind.br/pt/sustentabilidade"
    }
   ]
  }
 ]
}
